/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.article-info.service.ts.
 */
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {AppConfigService} from './app.config.service';
import {ArtikelInfo} from '../models/artikel-info';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DownloadedFile} from '../models/downloaded-file';

/**
 * Zweck: Beschreibt class AppArticleInfoService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppArticleInfoService {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient, private cfg: AppConfigService) {
  }

  private escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }

  private replaceAll(str, find, replace) {
    return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
  }

/**
 * Beschreibt Methode getPDF und ihren Rückgabevertrag.
 */
  getPDF(info: ArtikelInfo): Observable<DownloadedFile> {
    let fname = info.file.filename;
    fname = this.replaceAll(fname, '%', '');
    fname = this.replaceAll(fname, 'ä', 'ae');
    fname = this.replaceAll(fname, 'ö', 'oe');
    fname = this.replaceAll(fname, 'ü', 'ue');
    fname = this.replaceAll(fname, 'Ä', 'AE');
    fname = this.replaceAll(fname, 'Ö', 'OE');
    fname = this.replaceAll(fname, 'Ü', 'UE');

    return this.http.get(
      '/artikelinfo/' + info.id + '/' + fname + '.' + info.file.extension,
      {
        responseType: 'blob',
        observe: 'response'
      }
    ).pipe(map((resp) => {
      const contentDisposition = resp.headers.get('Content-Disposition');
      const contentType = resp.headers.get('Content-Type');
      const filename = info.file.filename + '.' + info.file.extension;

      return new DownloadedFile(filename, contentType, resp.body);
    }));
  }

/**
 * Beschreibt Methode getFile und ihren Rückgabevertrag.
 */
  getFile(info: ArtikelInfo) {
    const options = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders().set('Content-Type', info.file.mimetype)
    };

    return this.http.get<any>(
      '/artikelinfo/' + info.id + '/' + info.file.filename + '.' + info.file.extension,
      options
    ).pipe(map(res => {
      // trick to download store a file having its URL
      const fileURL = URL.createObjectURL(res);
      const a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = info.file.filename;
      document.body.appendChild(a);
      a.click();

      return true;
    }));
  }
}
